"use strict";
var indexCtrl = require('log/controllers/indexCtrl');
var navCtrl = require('common/controllers/navCtrl');
var app = angular.module('log', ['templates']);
app.controller('indexCtrl', ['$scope', '$rootScope', '$http', '$timeout', indexCtrl]);
app.controller('navCtrl', ['$scope', navCtrl]);
module.exports = app;
